import {useAuthUser} from "./hooks";

/**
 * Returns true if the current authenticated user has the given ability.
 * `admin` is a super-grant — admin users pass every ability check.
 */
export const useCan = (ability: string): boolean => {
  const user = useAuthUser();
  if (!user) return false;
  if (user.abilities?.includes("admin")) return true;
  return user.abilities?.includes(ability) ?? false;
};
